import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
const reviews = [{
  name: 'Carlos M.',
  text: 'Llevaba meses queriendo crear contenido pero no sabía por dónde empezar. Esta guía me dio un sistema claro y en un día ya tenía mi primer video listo.',
  stars: 5
}, {
  name: 'Andrea L.',
  text: 'No tenía idea de cómo usar IA para crear videos. Ahora tengo un proceso simple que sigo cada vez y los resultados hablan solos.',
  stars: 5
}, {
  name: 'Miguel R.',
  text: 'Pensaba que crear contenido viral era cuestión de suerte. Resulta que es cuestión de sistema. Esta guía me lo demostró.',
  stars: 5
}, {
  name: 'Sofía G.',
  text: 'Me sentí identificada desde la primera página. Pasé de no saber qué publicar a tener ideas claras y un proceso para ejecutarlas.',
  stars: 5
}];
export function ReviewsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-24 px-6 bg-dark-secondary" data-id="element-150">
      <div className="max-w-6xl mx-auto" data-id="element-151">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-serif font-bold text-text-primary mb-4 text-center" data-id="element-152">
          Lo que dicen quienes ya empezaron
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="text-text-secondary text-center mb-16 text-lg" data-id="element-153">
          Personas reales que estaban en tu misma situación.
        </motion.p>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-154">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: 0.15 + index * 0.1
        }} className="relative p-8 bg-dark-bg/60 rounded-lg border border-dark-tertiary" data-id="element-155">
              <QuoteIcon className="absolute top-6 right-6 w-8 h-8 text-accent/15" data-id="element-156" />

              <div className="flex gap-1 mb-4" data-id="element-157">
                {Array.from({
              length: review.stars
            }).map((_, i) => <StarIcon key={i} className="w-4 h-4 text-accent fill-accent" data-id="element-158" />)}
              </div>

              <p className="text-text-secondary text-base leading-relaxed mb-6" data-id="element-159">
                "{review.text}"
              </p>

              <div className="flex items-center gap-3" data-id="element-160">
                <div className="w-10 h-10 rounded-full bg-accent/10 flex items-center justify-center" data-id="element-161">
                  <span className="text-accent font-semibold text-sm" data-id="element-162">
                    {review.name.charAt(0)}
                  </span>
                </div>
                <span className="text-text-primary font-medium" data-id="element-163">
                  {review.name}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}